module.exports = __webpack_public_path__ + "img/arrowhead.cee43d3d.svg";